import { setProblemAsCompleted } from "../../../../services/userService";


export const customizedRegexTest = () => {


  async function RegexCheckProblems(studentCode, output, checkboxes, user, lessonID, lessonProblems) {
    const problemsArray = Array.isArray(lessonProblems.problems) ? lessonProblems.problems : Object.values(lessonProblems.problems);
    for (const problem of problemsArray) {
      const checkboxKey = `checkbox${problem.problemID}`;
      if (checkboxes[checkboxKey] !== true) {

        let passed = false;

        // --- TEST CODE STRUCTURE IF expectedCode IS USED ---
        if (problem.expectedCode && !problem.expectedOutput) {
          try {
            // Parse both student and expected code into AST
            const studentAST = studentCode.replace(/\r/g, '');
            const expectedAST = problem.expectedCode.replace(/\r/g, '');

            // Compare ASTs by stringified structure
            passed = JSON.stringify(studentAST) === JSON.stringify(expectedAST);
          } catch (err) {
            console.error("AST comparison failed:", err);
          }
        } else if (problem.expectedOutput !== null) {
          let cleanOutput = output.replace(/\r\n/g, '').replace(/\n/g, '').replace(/\\n/g, '').trim();

          if (cleanOutput === 'No output') {
            cleanOutput = '';
          }

          const safeExpectedOutput = problem.expectedOutput.trim();
          const cleanedSafeExpectedOutput = safeExpectedOutput.replace(/\r\n/g, '').replace(/\n/g, '').replace(/\\n/g, '').trim();

          const outputRegex = new RegExp(cleanedSafeExpectedOutput);


          // if (safeExpectedOutput.endsWith('\\n$') && !cleanOutput.endsWith('\n')) {
          //     cleanOutput += '\n';
          // }

          passed = outputRegex.test(cleanOutput);
        }

        if (passed) {
          await setProblemAsCompleted(lessonID, problem.problemID, user.uid, user.role);
          checkboxes[checkboxKey] = true;
          // console.log(`✅ Problem ${problem.problemID} passed`);
        } else {
          checkboxes[checkboxKey] = 'fail';
          // console.log(`❌ Test failed for ${problem.problemID}`);
        }
        break;

      }
    }
    return checkboxes;
  }


  return { RegexCheckProblems }
}